import React from 'react';

import { Text } from 'apps/auth/components/common/Text/Text';

import CountryItemWithCode from './CountryItemWithCode';

const RecentCountriesWithCode = (props) => {
    return (
        <>
            <Text variant="div" color="secondary" size="subheader" indent="adaptive-16-24">
                {props.suggested}
            </Text>
            {props.suggestedCountries.map((country) => {
                const key = `countryList_${country.code}`;
                return <CountryItemWithCode key={key} country={country} iso2={props.iso2} onCountryItemClick={props.onCountryItemClick} />;
            })}
        </>
    );
};

export default RecentCountriesWithCode;
